const Management = {};

export default Management